import React, { useState } from 'react';

import ModalContainer from '@components/modals/ModalContainer';

import { NEW_COSTING_OPTION_REASONS } from './costingOptionUtil';

const CreateCostingOptionModal = ({ closeModal, onSubmit, reasons = NEW_COSTING_OPTION_REASONS }) => {
	const [selectedReasons, setSelectedReasons] = useState([]);

	const toggleReason = (value) => {
		setSelectedReasons((prev) =>
			prev.includes(value) ? prev.filter((item) => item !== value) : [...prev, value]
		);
	};

	return (
		<ModalContainer onCloseModal={closeModal} size="md" className="new-costing-option-modal width-430">
			<div className="popup-wrapper">
				<div className="common-popup width-430 shadow-24dp">
					<div className="common-popup-header d-flex justify-content-between">
						<div className="popup-tilte">
							<h3 className="semibold-16 mb-0">Create new costing option</h3>
						</div>
						<div className="close-btn">
							<img
								src={`${process.env.PUBLIC_URL}/icons/close.svg`}
								alt="close"
								className="cursor-pointer"
								onClick={closeModal}
							/>
						</div>
					</div>
					<div className="common-popup-body">
						<p className="regular-14 gray_dark_02">
							Select for which reasons you are creating new option
						</p>
						<div className="costing-option-reason-list">
							{reasons.map((reason) => (
								<div
									className="costing-input custom-chekbox"
									key={`costing_option_reason_${reason.value}`}
								>
									<div className="form-group m-0">
										<input
											type="checkbox"
											id={`costing_option_reason_${reason.value}`}
											name="costingOptionReason"
											checked={selectedReasons.includes(reason.value)}
											onChange={() => toggleReason(reason.value)}
										/>
										<label
											className="regular-14"
											htmlFor={`costing_option_reason_${reason.value}`}
										>
											<span>{reason.label}</span>
										</label>
									</div>
								</div>
							))}
						</div>
					</div>
					<div className="modal-footer">
						<div className="footer-buttons text-right">
							<button className="button gray-outline size32" onClick={closeModal}>
								Cancel
							</button>
							<button
								className="button size32 ml-2"
								disabled={!selectedReasons.length}
								onClick={() => onSubmit(selectedReasons)}
							>
								Submit
							</button>
						</div>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default CreateCostingOptionModal;
